import { environment } from 'src/environments/environment';

/** Production portal for add-ons / legacy contact sales forms. */
export const HUBSPOT_ADDON_PORTAL_ID = '495102';

/** Test portal for plan-feature upsell contact sales form. */
export const HUBSPOT_FEATURE_UPSELL_TEST_PORTAL_ID = '51205612';

/** Production portal for plan-feature upsell contact sales form. */
export const HUBSPOT_FEATURE_UPSELL_PRODUCTION_PORTAL_ID = '495102';

export const HUBSPOT_DEFAULT_REGION = 'na1';

/** Legacy add-ons page and classic upsell pages (Benchmarks, VSR, etc.). */
export const HUBSPOT_ADDON_CONTACT_SALES_FORM_ID = '0f2c3c14-a818-4c2c-aa8a-d26a40c0c741';

/** Plan-feature upsells (Web & App Usage, Schedules, Internet Connectivity, etc.). */
export const HUBSPOT_FEATURE_UPSELL_CONTACT_SALES_FORM_ID = 'ccbc38d2-bde1-4d07-9314-02c6fdff1928';

export type HubspotContactSalesFormKind = 'addon' | 'feature-upsell';

/**
 * True for local dev, staging builds, and test hostnames (e.g. 2.timedoctortest.com).
 * Optional hostname supports unit tests without mocking window.location.
 */
export function isHubspotTestEnvironment(hostname?: string): boolean {
  if (!environment.production || environment.deployment === 'staging') {
    return true;
  }

  const host = hostname ?? globalThis.location?.hostname ?? '';

  return host.includes('timedoctortest.com')
    || host.includes('timedoctordev.com')
    || host === 'localhost';
}

export function resolveHubspotPortalId(kind: HubspotContactSalesFormKind = 'addon'): string {
  if (kind === 'feature-upsell') {
    if (environment.hubspotFeatureUpsellPortalId) {
      return environment.hubspotFeatureUpsellPortalId;
    }

    return isHubspotTestEnvironment()
      ? HUBSPOT_FEATURE_UPSELL_TEST_PORTAL_ID
      : HUBSPOT_FEATURE_UPSELL_PRODUCTION_PORTAL_ID;
  }

  return environment.hubspotPortalId || HUBSPOT_ADDON_PORTAL_ID;
}

export function resolveHubspotRegion(): string {
  return environment.hubspotRegion || HUBSPOT_DEFAULT_REGION;
}

export function resolveHubspotContactSalesFormId(kind: HubspotContactSalesFormKind): string {
  if (kind === 'feature-upsell') {
    return environment.hubspotFeatureUpsellFormId || HUBSPOT_FEATURE_UPSELL_CONTACT_SALES_FORM_ID;
  }

  return environment.hubspotFormId || HUBSPOT_ADDON_CONTACT_SALES_FORM_ID;
}
